module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('Form', [_c('Row', [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('SHENQINGREN')
    }
  }, [_vm._v(_vm._s(_vm.item.userName))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('SHENGQINGSHIJIAN')
    }
  }, [_vm._v(_vm._s(_vm.item.applyTime))])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('SHENQINGLEIXING')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.item.applyBizType == "SELF_LEVELING" ?
    _vm.l("JIANGSHITIAOJI") :
    _vm.l("JIANGSHISHENQING")) + "\n        ")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('JIANGSHILEIBIE')
    }
  }, [_vm._v(_vm._s(_vm.item.categoryName))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('JIANGSHIJIBIE')
    }
  }, [_vm._v(_vm._s(_vm.item.levelName))])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('SHENQINGYUANYING')
    }
  }, [_vm._v(_vm._s(_vm.item.applyDescription))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a917b0f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":true}!./src/shared/views/userTeacherAudit.vue
// module id = 931
// module chunks = 80